import React, { useEffect, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Alert, Col, Dropdown, Row, Tag } from 'antd'
import {
  formatDate,
  formatDateTime,
  formatDateWithoutTime,
  getSupplierPaymentType,
  numberWithComma,
} from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/grn-payment/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { selectAllSupplierList } from 'Store/supplier/selector'
import { InfoItem } from 'Pages/Merchants/components'
import { PrimaryButton } from 'Components/button'
import { MenuPrints, MultiUploadForm } from 'Components/form'
import { selectPaymentActionEvent } from 'Store/grn-payment/selector'
import { PrinterOutlined } from '@ant-design/icons'
import SaleInvoicePDF from './SaleInvoicePDF'
import { TableListPage } from 'Components/common/Table'
import { getPatialDetailAPI } from 'Store/supplier-invoice/api'
import { PatialDetailReq } from 'Store/supplier-invoice/types'
import { selectPartialDetail, selectPartialDetailEvent } from 'Store/supplier-invoice/selector'
import { PaymentTypes } from 'helpers/constanst'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  id?: number
  remailAmount?: number
}

const PaymentDetail: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, currentUser, event, detail, detailEvent, id, remailAmount = 0 } = props
  const invoicePDF = useRef(null as any)
  const invoiceLitePDF = useRef(null as any)
  const bill = detail?.partial
  const isVoid = bill?.payment_channel === PaymentTypes.VOID

  const dispatch = useDispatch()

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [visible])

  const onGetDetail = (): void => {
    const req: PatialDetailReq = {
      id: id || 0,
    }
    dispatch(getPatialDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onGetDetail()
    //onSuccess()
  }

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const renderPaymentInfo = () => {
    return (
      <BoxWrapper>
        <BoxTitle>รายละเอียดการรับชำระหนี้จากลูกหนี้</BoxTitle>
        <Row gutter={8}>
          <Col md={12} xs={24}>
            {renderInfo('เลขที่ใบเสร็จ', bill?.receipt_no)}
            {renderInfo('วันที่ทำรายการ', formatDateTime(detail?.partial?.created_at || ''))}
            {/* {renderInfo('วันที่ชำระ', formatDateTime(bill?.payment_date || ''))} */}
          </Col>
          <Col md={12} xs={24}>
            {renderInfo('ยอดที่ชำระ', `${numberWithComma(bill?.amount || 0, true)} บาท`)}
            {renderInfo(
              'ประเภทการชำระ',
              `${bill?.payment_type === 'partial' ? 'แบ่งชำระ' : 'ชำระเต็มจำนวน'}`,
            )}
            {renderInfo('ผู้รับชำระ', bill?.officer)}
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  // const renderClientInfo = () => {
  //   return (
  //     <BoxWrapper>
  //       <BoxTitle>รายละเอียดลูกค้า/คู่ค้า</BoxTitle>
  //       <Row gutter={8}>
  //         <Col md={24} xs={24}>
  //           {renderInfo('บริษัท/Supplier', detail?.customer?.name)}
  //           {renderInfo('ที่อยู่', detail?.customer?.address)}
  //           {renderInfo('เบอร์โทรศัพท์', detail?.customer?.mobile)}
  //           {renderInfo('อีเมล', detail?.customer?.email)}
  //           {renderInfo('ประเภทลูกค้า', detail?.customer?.type)}
  //         </Col>
  //       </Row>
  //     </BoxWrapper>
  //   )
  // }

  // const renderPurchaseInfo = () => {
  //   return (
  //     <BoxWrapper>
  //       <BoxTitle>รายละเอียดร้านค้า</BoxTitle>
  //       {renderInfo('ชื่อ', detail?.merchant?.name)}
  //       {renderInfo(
  //         'ที่อยู่',
  //         formatAddress(
  //           detail?.merchant?.address,
  //           detail?.merchant?.district,
  //           detail?.merchant?.amphor,
  //           detail?.merchant?.province,
  //           detail?.merchant?.postcode,
  //         ),
  //       )}
  //       {renderInfo('เบอร์โทรศัพท์', detail?.merchant?.phone)}
  //     </BoxWrapper>
  //   )
  // }

  const renderTitle = () => {
    return (
      <Row>
        <Col span={23}>
          <Alert
            message="ชำระหนี้สำเร็จ"
            description={`เลขที่ใบเสร็จ : ${bill?.receipt_no}`}
            type="success"
            showIcon
          />
        </Col>
      </Row>
    )
  }

  const paymentRef = () => {
    return (
      <BoxWrapper>
        <Row>
          <Col md={12} xs={24}>
            <BoxTitle>หลักฐานการรับชำระเงิน</BoxTitle>
            {renderInfo('รูปแบบการชำระเงิน', getSupplierPaymentType(bill?.payment_channel))}
            {renderInfo('วันที่ชำระเงิน', formatDateTime(bill?.payment_date || ''))}
            {renderInfo('หมายเหตุ', bill?.reason || '')}
          </Col>
          <Col md={12} xs={24}>
            <MultiUploadForm
              token={''}
              onUpdateData={() => {}}
              files={bill?.payment_slips || []}
              folder="supplier-payment-slips"
              isPrivate={true}
              name="payment_slips"
              description=""
              isRequired={false}
              isError={false}
              label="หลักฐานการรับชำระเงิน"
              readOnly={true}
            />
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      width: '50px',
      render: (value: any, record: any, index: number) => {
        return index + 1
      },
    },
    {
      title: 'เลขที่คำสั่งซื้อ',
      dataIndex: 'sale_order_no',
      key: 'sale_order_no',
    },
    {
      title: 'เลขที่ใบเสนอราคา',
      dataIndex: 'quotation_no',
      key: 'quotation_no',
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => formatDateTime(val),
    },
    {
      title: 'วันที่จัดส่ง',
      dataIndex: 'delivery_date',
      key: 'delivery_date',
      render: (val: string) => formatDateWithoutTime(val),
    },
    {
      title: 'ยอดชำระ',
      dataIndex: 'partials',
      key: 'partials',
      render: () => numberWithComma(bill?.amount || 0, true),
    },
  ]

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      width={'90%'}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 16]}>
        <Col md={24} xs={24}>
          {renderPaymentInfo()}
        </Col>
        {/* <Col md={12} xs={24}>
          {renderClientInfo()}
        </Col> */}
        {/* <Col md={24} xs={24}>
          {renderPurchaseInfo()}
        </Col> */}
        {/* <Col md={24} xs={24}>
          <ClientInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          <DeliveryInfo detail={detail} />
        </Col> */}
        <Col md={24} xs={24}>
          {paymentRef()}
        </Col>
        <Col span={24}>
          <BoxWrapper>
            <Row justify="space-between">
              <Col>
                <BoxTitle>รายการชำระหนี้</BoxTitle>
              </Col>
              <Col>
                {/* <ReactToPrint
                  trigger={() => {
                    return (
                      <PrimaryButton
                        btnType="Primary"
                        text="พิมพ์ใบเสร็จ"
                        icon={<PrinterOutlined />}
                        onClick={() => {}}
                        size="middle"
                      />
                    )
                  }}
                  content={() => invoicePDF.current}
                  documentTitle={`ใบเสร็จ-${bill?.receipt_no}`}
                /> */}
                <Dropdown
                  key="more"
                  overlay={
                    <MenuPrints
                      nomalPrintRef={invoicePDF}
                      litePrintRef={invoiceLitePDF}
                      title={`ใบเสร็จ-${bill?.receipt_no}`}
                    />
                  }
                  trigger={['click', 'hover']}
                >
                  <PrimaryButton
                    btnType="Approve"
                    text="พิมพ์ใบเสร็จ"
                    icon={<PrinterOutlined />}
                    onClick={() => {}}
                    size="middle"
                  />
                </Dropdown>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col md={24} xs={24}>
                <TableListPage
                  rowKey="option_id"
                  tableName="reduce-dept"
                  columns={columns}
                  datas={[detail]}
                  size={'small'}
                  scrollX={400}
                />{' '}
              </Col>
            </Row>

            <Row justify="space-between">
              <Col>
                ประเภทการชำระ :{' '}
                <Remark> {bill?.payment_type === 'partial' ? 'แบ่งชำระ' : 'ชำระเต็มจำนวน'} </Remark>
              </Col>
              <Col>
                ยอดที่ชำระทั้งสิ้น <Price>{numberWithComma(bill?.amount || 0, true)}</Price> บาท
              </Col>
            </Row>
          </BoxWrapper>
        </Col>
      </Row>
      <Row ref={invoicePDF}>
        <Col span={24}>
          <SaleInvoicePDF detail={detail} remailAmount={remailAmount} />
        </Col>
      </Row>
      <Row ref={invoiceLitePDF}>
        <Col span={24}>
          <SaleInvoicePDF detail={detail} remailAmount={remailAmount} isLite={true} />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Price = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`

const Remark = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectPaymentActionEvent(state),
    detail: selectPartialDetail(state),
    detailEvent: selectPartialDetailEvent(state),
    supplierList: selectAllSupplierList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PaymentDetail)
